import { all, put, SagaIterator, takeEveryCompletedRequest, takeEveryErrorRequest } from './core/sagaEffects';
import { AddNotification, FetchRequest } from 'acscp/actions';
import { ResponseErrorTypes, ResponseType } from 'acscp/api/responses/core/responseTypes';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import { AccountLinksRequest, DeleteAccountLinkRequest } from 'acscp/api/requests';
import { defineMessages } from 'react-intl';
import { NotificationType } from 'acscp/store/notificationState';

const messages = defineMessages({
    success: {
        id: 'sagas.deleteAccountLinkSaga.successNotification',
        defaultMessage: 'The following user\'s access to your account has been revoked: {emailAddress}'
    }
});

const deleteAccountLinkRequestSuccess = 'deleteAccountLinkRequestSuccess';

export function* deleteAccountLinkSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(DeleteAccountLinkRequest, handleHandleDeleteAccountLinkSuccess),
        takeEveryErrorRequest(DeleteAccountLinkRequest, handleHandleDeleteAccountLinkErrors)
    ]);
}

export function* handleHandleDeleteAccountLinkSuccess(
    response: undefined,
    request: DeleteAccountLinkRequest
): SagaIterator {
    yield put(new FetchRequest(new AccountLinksRequest()));
    yield put(new AddNotification(
        deleteAccountLinkRequestSuccess, messages.success, NotificationType.Info, undefined, {emailAddress: request.emailAddress}));
}

export function* handleHandleDeleteAccountLinkErrors(
    responseType: ResponseErrorTypes,
    error: ErrorDetails,
    request: DeleteAccountLinkRequest
): SagaIterator {
    if (responseType === ResponseType.RequestError) {
        yield put(new FetchRequest(new AccountLinksRequest()));
    }
}
